// src/app/services/loading.service.ts
import { Injectable, computed, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {

  //* GENERIC LOADING
  private readonly _loadingCount: WritableSignal<number> = signal(0);
  public readonly isLoading = computed(() => this._loadingCount() > 0);
  startLoading(): void {
    this._loadingCount.update(currentCount => currentCount + 1);
  }
  stopLoading(): void {
    this._loadingCount.update(currentCount => Math.max(0, currentCount - 1));
  }


  //* EVENTS LOADING
  private readonly _loadingEventsCount: WritableSignal<number> = signal(0);
  public readonly isLoadingEvents = computed(() => this._loadingEventsCount() > 0);
  startEventLoading(): void {
    this._loadingEventsCount.update(currentCount => currentCount + 1);
  }
  stopEventLoading(): void {
    this._loadingEventsCount.update(currentCount => Math.max(0, currentCount - 1));
  }


  //* MOTIVOS LOADING
  private readonly _loadingMotivosCount: WritableSignal<number> = signal(0);
  public readonly isLoadingMotivos = computed(() => this._loadingMotivosCount() > 0);
  startMotivoLoading(): void {
    this._loadingMotivosCount.update(currentCount => currentCount + 1);
  }
  stopMotivoLoading(): void {
    this._loadingMotivosCount.update(currentCount => Math.max(0, currentCount - 1));
  }
}
